export enum CreateProjectDirectoryType {
  DEFAULT = 'DEFAULT',
  NEW_PROJEKT_DIR = 'NEW_PROJEKT_DIR',
  CUSTOMER_DIRECTORY = 'CUSTOMER_DIRECTORY',
  EXISTING_DIRECTORY = 'EXISTING_DIRECTORY',
}
